"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _FormikExtended = _interopRequireDefault(require("@sprinx/react-forms/FormikExtended"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _usePreferredLocale = _interopRequireDefault(require("@sprinx/react-globalize/usePreferredLocale"));

var _useSnackbar3 = _interopRequireDefault(require("@sprinx/react-mui-layout/useSnackbar"));

var _useProductQuestionCallCreate = _interopRequireDefault(require("./useProductQuestionCallCreate"));

var _ProductDetailQuestionForm = _interopRequireDefault(require("./ProductDetailQuestionForm"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'ProductDetailQuestion'
});

function ProductDetailQuestion(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var createQuestion = (0, _useProductQuestionCallCreate.default)();
  var t = (0, _useTranslate.default)();
  var locale = (0, _usePreferredLocale.default)();

  var _useSnackbar = (0, _useSnackbar3.default)(),
      _useSnackbar2 = (0, _slicedToArray2.default)(_useSnackbar, 1),
      showMessage = _useSnackbar2[0];

  var handleSubmit = _react.default.useCallback( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values, _ref2) {
      var resetForm, setSubmitting, nValues;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resetForm = _ref2.resetForm, setSubmitting = _ref2.setSubmitting;

              if (!(values.gdpr !== true)) {
                _context.next = 5;
                break;
              }

              setSubmitting(false);
              showMessage(t('productQuestion/title'), {
                variant: 'error'
              });
              return _context.abrupt("return", null);

            case 5:
              nValues = (0, _extends2.default)({}, values);
              return _context.abrupt("return", createQuestion(nValues).then(function () {
                setSubmitting(false);
                resetForm({});
                showMessage(t('productQuestion/success'), {
                  variant: 'success'
                });
              }).catch(function (err) {
                console.log(err); // eslint-disable-line no-console

                setSubmitting(false);
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [createQuestion, showMessage, t]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_FormikExtended.default, {
    initialValues: {
      firstName: '',
      lastName: '',
      locale: locale,
      product: product,
      subject: t('productQuestion/subjectContent', {
        product: t(product.name),
        sku: product.sku
      }),
      question: '',
      gdpr: false
    },
    onSubmit: handleSubmit,
    validationSchema: {
      firstName: {
        type: 'string',
        empty: false,
        min: 3,
        max: 25
      },
      lastName: {
        type: 'string',
        empty: false,
        min: 3,
        max: 25
      },
      email: {
        type: 'email'
      },
      subject: {
        type: 'string',
        empty: false,
        min: 3
      },
      question: {
        type: 'string',
        empty: false,
        min: 3
      }
    },
    validationFastest: {
      messages: {
        enumValue: t('appProductDetailTabs/form/enum')
      }
    },
    validateOnBlur: true,
    validateOnChange: true
  }, function (frmkProps) {
    return /*#__PURE__*/_react.default.createElement(_ProductDetailQuestionForm.default, frmkProps);
  }));
}

process.env.NODE_ENV !== "production" ? ProductDetailQuestion.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    name: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    sku: _propTypes.default.string
  })
} : void 0;
ProductDetailQuestion.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined
};
var _default = ProductDetailQuestion;
exports.default = _default;